
import { defineComponent, ref, onMounted } from "vue";
import { themeName, demo } from "@/core/helpers/documentation";
import ApiService from "@/core/services/ApiService";

export default defineComponent({
  name: "ethoca-drawer",
  props: {
    alert: {type: Object, required: true},
  },
  setup() {
    const input2 = ref("");
    const connections = ref([]);
    onMounted(() => {
      setTimeout(async () => {
        const res = await ApiService.get(
          `apis/connections?limit=100&group[category]=Gateway`
        );
        connections.value = res.data.data;
      }, 1000);
    });
    return {
      themeName,
      input2,
      demo,
      connections,
    };
  },
});
